<template>
	<div class="layout-container" :class="[isPC ? 'PC' : 'Mobile', isHomePage ? 'h-100' : '', isEN ? 'EN' : '']">
		<div
			class="layout-nav layout-center-container"
			:class="{
				// 障眼法 非第一屏滚动的时候隐藏Nav
				'layout-nav--translate': isPC && fullSwiperIndex !== 0
			}"
		>
			<transition :name="transitionName">
				<PCNav v-if="isPC" key="before" :scale="headerScale" />
				<MobileNav v-else key="after" ref="mobileMenu" />
			</transition>
		</div>

		<template v-if="!isHomePage">
			<div :class="['layout-header', isPC ? routeName : `m-${routeName}`]">
				<HeaderBanner>
					<div v-if="isPC && history.length" class="header-history">
						<div
							v-for="(item, index) in history"
							:key="index"
							class="header-history-item"
							:class="{
								'header-history-item--active': index === history.length - 1
							}"
						>
							<span @click="handleHistory(item)">{{ item.label }}</span>
							<c-svg-icons
								v-if="index < history.length - 1"
								name="icon_jiantou"
								color="#e5e6e8"
								size="16"
								class="header-history-svg"
							/>
						</div>
					</div>
				</HeaderBanner>
			</div>

			<div class="layout-main layout-center-container">
				<!-- 首页固定缓存 -->
				<keep-alive :include="['home']">
					<router-view></router-view>
				</keep-alive>
			</div>

			<div v-if="!shouldHideInfo" class="layout-footer">
				<PCFooter v-if="isPC" :scale="headerScale"></PCFooter>
				<MobileFooter v-else></MobileFooter>
			</div>

			<div v-if="!shouldHideInfo" class="fixed-action">
				<div
					class="action-block"
					:class="{ 'action-block--disabled': scrollDisabled }"
					@click="handleAction('top')"
				>
					<c-svg-icons name="icon_top" size="24" class="c-action-svg" />
					<span class="action-block-span">{{ $t('common.back_to_top') }}</span>
				</div>
			</div>
		</template>
		<template v-else>
			<div v-if="!isPC">
				<div :class="['layout-header', isPC ? routeName : `m-${routeName}`]">
					<HeaderBanner></HeaderBanner>
				</div>
				<img :src="mobileCoverSrc" style="width: 100%;" />
				<div v-if="!shouldHideInfo" class="layout-footer">
					<MobileFooter></MobileFooter>
				</div>
			</div>
			<swiper v-else :options="swiperOption" ref="swiperRef" style="height: 100%">
				<!-- 首页开启全屏轮播 -->
				<swiper-slide>
					<div :class="['layout-header', isPC ? routeName : `m-${routeName}`]">
						<HeaderBanner></HeaderBanner>
					</div>
				</swiper-slide>

				<swiper-slide v-for="(item, index) in coverList" :key="index">
					<div
						class="cover-wrap"
						:style="item.bg ? { '--slide-bg': item.bg } : {}"
					>
						<img
							class="cover-img"
							:src="item.src"
							alt=""
							:style="{
								objectPosition: item.objPos || 'center',
								mixBlendMode: item.blendMode || 'normal'
							}"
						/>
					</div>
				</swiper-slide>

				<swiper-slide>
					<div v-if="!shouldHideInfo" class="layout-footer">
						<PCFooter v-if="isPC" :scale="headerScale"></PCFooter>
						<MobileFooter v-else></MobileFooter>
					</div>
				</swiper-slide>
			</swiper>
		</template>
	</div>
</template>

<script>
import { MENU } from '@/utils/const';
import 'swiper/swiper-bundle.css';
import SwiperCore, { Mousewheel } from 'swiper';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
SwiperCore.use([Mousewheel]);
import i18n, { EN } from '@/locales';

export default {
	components: {
		Swiper,
		SwiperSlide
	},
	data() {
		return {
			history: [],
			routeName: '',
			shouldHideInfo: false
		};
	},
	computed: {
		isHomePage() {
			return this.$route.name === 'home';
		},
		isEN() {
			return i18n.locale === EN;
		}
	},
	watch: {
		'$route': {
			handler(val) {
				const { hash, name } = val;
				if (name === 'announcementSearch') {
					this.shouldHideInfo = true;
				} else {
					this.shouldHideInfo = false;
				}

				this.history = this.findItemRecursive(MENU(), hash ? hash.split('#')[1] : name) || [];
				this.routeName = val.name;
			},
			immediate: true,
			deep: true
		}
	},
	methods: {
		handleHistory(item) {
			if (!item.name) return;
			if (item.name === this.$route.name) return;

			// 检查当前路由是否有语言参数，如果有则保留
			const currentLang = this.$route.params.lang;

			// 获取路由路径，如果没有映射则使用路由名称
			const routePath = item.name;
			let targetPath = `/${routePath}`;

			// 如果有语言参数，添加语言前缀
			if (currentLang) {
				targetPath = `/${currentLang}${targetPath}`;
			}

			this.$router.replace({
				path: targetPath,
				query: this.$route.query,
				hash: this.$route.hash
			});
		},
		gotoAppoint() {
			// TODO prod
			// window.open(
			// 	'https://testmobile.comein.cn/mobile/enrollment/appoint?id=6766&name=爱迪特&hengshengCode=301580.SZ'
			// );
		},
		findItemRecursive(tree, itemId, path = []) {
			for (const item of tree) {
				if ((item.id || item.name) === itemId) {
					// 找到目标项
					return [...path, item];
				}

				if (item.children && item.children.length > 0) {
					const result = this.findItemRecursive(item.children, itemId, [...path, item]);
					if (result) {
						// 子树中找到目标项
						return result;
					}
				}
			}

			// 未找到目标项
			return null;
		}
	}
};
</script>
<script setup>
import { ref, onMounted, onBeforeUnmount, computed, watch } from 'vue';
import { debounce, useStore, useRouter } from '@/utils/api';
import MobileFooter from '@/views/layout/components/mobile-footer.vue';
import MobileNav from '@/views/layout/components/mobile-nav.vue';
import PCNav from '@/views/layout/components/pc-nav.vue';
import HeaderBanner from '@/views/layout/components/header-banner.vue';
import PCFooter from '@/views/layout/components/pc-footer.vue';

const headerScale = ref(1);
const scrollDisabled = ref(true);
const handleScroll = () => {
	const threshold = 450; // 设置阈值高度，当滚动超过这个高度时切换状态
	const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	scrollDisabled.value = scrollTop < threshold;
};

const resizeEvt = 'orientationchange' in window ? 'orientationchange' : 'resize';
const calcScale = () => {
	const w = document.documentElement.clientWidth;
	const s = w / 1920;
	console.log('-------------- s:', s);
	headerScale.value = Math.min(s, 1);

	observerAndUpdateWidth();
};

const transitionName = ref('none');
const width = ref(1920);
const store = useStore();
const isPC = computed(() => store.getters.isPC);
const observerAndUpdateWidth = () => {
	requestAnimationFrame(() => {
		width.value = window.innerWidth ? window.innerWidth : screen.availWidth;
		store.commit('setDevice', width.value >= 992 ? 'PC' : 'Mobile');
	});
};
const mobileMenu = ref();
watch(
	() => isPC.value,
	val => {
		updateSwiperView();
		sessionStorage.setItem('isPC', val);
		if (val) mobileMenu.value?.hide();
	}
);

const router = useRouter();
router.afterEach(() => {
	// reset
	fullSwiperIndex.value = 0;
});
const fullSwiperIndex = ref(0);
const changeSwiper = () => {
	const actIdx = getSwiper.value?.activeIndex;
	fullSwiperIndex.value = actIdx;
};

const lockSwiper = () => {
	getSwiper.value?.mousewheel.disable(); //禁止鼠标滑轮控制
};
const unlockSwiper = () => {
	console.log('unlock');
	setTimeout(() => {
		getSwiper.value?.mousewheel.enable(); //开启鼠标滑轮控制
	}, 1500);
};

const swiperRef = ref();
const swiperOption = {
	slidesPerView: 'auto',
	direction: 'vertical',
	resistanceRatio: 0,
	autoHeight: true, //高度随内容变化
	speed: 900, //900
	mousewheel: true,
	lazy: {
		loadPrevNext: true,
		loadOnTransitionStart: true
	},
	// 鼠标模拟手机触摸。默认为true，Swiper接受鼠标点击、拖动。
	simulateTouch: false,
	on: {
		slideChange: () => {
			changeSwiper();
		},
		transitionStart: () => {
			console.log('------ start.');
			lockSwiper();
		},
		transitionEnd: () => {
			console.log('------ end.');
			unlockSwiper();
		}
	}
};
const getSwiper = computed(() => swiperRef.value?.$swiper);

const updateSwiperView = () => {
	requestAnimationFrame(() => {
		swiperRef.value?.swiper?.update(true);
	});
};
const coverConfig = {
	'zh-cn': [
		{
			src: require('@/assets/images/banner/2026-05-19/PC-zh_cn/cover_01.jpg'),
			bg: 'rgb(246,252,252)',
			blendMode: 'darken',
			objPos: 'center -15px'
		},
		{
			src: require('@/assets/images/banner/2026-05-19/PC-zh_cn/cover_02.jpg'),
			objPos: 'center -15px'
		},
		{
			src: require('@/assets/images/banner/2026-05-19/PC-zh_cn/cover_03.jpg'),
			objPos: 'center'
		},
		{
			src: require('@/assets/images/banner/2026-05-19/PC-zh_cn/cover_04.jpg'),
			bg: 'rgb(232,233,238)',
			objPos: 'center -15px'
		},
		{
			src: require('@/assets/images/banner/2026-05-19/PC-zh_cn/cover_05.jpg'),
			objPos: 'center -15px'
		}
	],
	'en': [
		{
			src: require('@/assets/images/banner/2026-05-19/PC-en/cover_01.jpg'),
			bg: 'rgb(246,252,252)',
			blendMode: 'darken',
			objPos: 'center -15px'
		},
		{
			src: require('@/assets/images/banner/2026-05-19/PC-en/cover_02.jpg'),
			objPos: 'center -15px'
		},
		{
			src: require('@/assets/images/banner/2026-05-19/PC-en/cover_03.jpg'),
			objPos: 'center'
		},
		{
			src: require('@/assets/images/banner/2026-05-19/PC-en/cover_04.jpg'),
			bg: 'rgb(232,233,238)',
			objPos: 'center -15px'
		},
		{
			// cover_04 与 cover_05 为同一内容块的前后页，共享背景色以保持视觉连贯
			src: require('@/assets/images/banner/2026-05-19/PC-en/cover_05.jpg'),
			bg: 'rgb(232,233,238)',
			objPos: 'center -15px'
		},
		{
			src: require('@/assets/images/banner/2026-05-19/PC-en/cover_06.jpg'),
			objPos: 'center -15px'
		}
	]
}

const coverList = computed(() => coverConfig[i18n.locale] || coverConfig['zh-cn'])

const mobileCoverMap = {
	'zh-cn': require('@/assets/images/banner/2026-05-19/Mobile/full-image-zh_cn.jpg'),
	'en': require('@/assets/images/banner/2026-05-19/Mobile/full-image-en.png')
}

const mobileCoverSrc = computed(() => mobileCoverMap[i18n.locale] || mobileCoverMap['zh-cn'])

onMounted(() => {
	// 避免第一次进入页面时 触发动效
	setTimeout(() => {
		transitionName.value = 'fade';
	}, 120);

	calcScale();
	window.addEventListener(resizeEvt, debounce(calcScale, 200), false);
	window.addEventListener('scroll', handleScroll);
});
onBeforeUnmount(() => {
	window.removeEventListener(resizeEvt, calcScale);
	window.removeEventListener('scroll', handleScroll);
});

const handleAction = debounce(
	function (type) {
		switch (type) {
			case 'top':
				if (scrollDisabled.value) return;
				window.scrollTo({
					top: 0,
					behavior: 'smooth'
				});
				break;

			default:
				break;
		}
	},
	200,
	true
);
</script>

<style lang="less" scoped>
.layout-container {
	&.h-100 {
		height: 100vh;
	}

	.layout-nav {
		position: relative;
		z-index: 999;
		transition: transform 0.32s ease;

		&--translate {
			transform: translateY(-100px);
		}
	}

	.layout-header {
		position: relative;
		&::before {
			content: '';
			display: block;
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
			top: 0;
			background: rgba(0, 0, 0, 0.3);
		}
	}
	.home {
		background: url(@/assets/images/banner/banner1.jpg) no-repeat;
		background-size: cover;
		background-position: center top;
	}
	.m-home {
		background: url(@/assets/images/banner/m-banner1.jpg) no-repeat;
		background-size: cover;
		background-position: center top;
	}
	.business_rules,
	.sustain {
		background: url(@/assets/images/banner/banner2.jpg) no-repeat;
		background-size: cover;
		background-position: center top;
	}
	.m-business_rules,
	.m-sustain {
		background: url(@/assets/images/banner/m-banner2.jpg) no-repeat;
		background-size: cover;
		background-position: center top;
	}
	.investment,
	.news,
	.analyst,
	.report,
	.presentation,
	.m-investment,
	.m-news,
	.m-analyst,
	.m-report,
	.m-presentation {
		background: url(@/assets/images/banner/banner3.png) no-repeat;
		background-size: cover;
		background-position: center 20%;
	}

	.quote {
		background: url(@/assets/images/banner/banner6.jpg) no-repeat;
		background-size: cover;
		background-position: center top;
	}
	.m-quote {
		background: url(@/assets/images/banner/m-banner6.jpg) no-repeat;
		background-size: cover;
		background-position: center top;
	}

	.quarterly_performance,
	.announcement {
		background: url(@/assets/images/banner/banner4.jpg) no-repeat;
		background-size: cover;
		background-position: center top;
	}

	.m-quarterly_performance,
	.m-announcement,
	.m-announcementSearch {
		background: url(@/assets/images/banner/m-banner4.jpg) no-repeat;
		background-size: cover;
		background-position: center top;
	}

	.question,
	.contact {
		background: url(@/assets/images/banner/banner5.jpg) no-repeat;
		background-size: cover;
		background-position: center top;
	}

	.m-question,
	.m-contact {
		background: url(@/assets/images/banner/m-banner5.jpg) no-repeat;
		background-size: cover;
		background-position: center top;
	}

	.header-history {
		margin-top: -50px;
		height: 50px;
		display: flex;
		align-items: center;

		&::before {
			content: '';
			display: block;
			position: absolute;
			left: 0;
			right: 0;
			bottom: 0;
			height: inherit;
			background: rgba(0, 0, 0, 0.2);
			pointer-events: none;
		}
	}
	.header-history-item {
		position: relative;

		span {
			color: rgba(255, 255, 255, 0.6);
			font-family: 'SourceHanSansCN-Normal';
			font-size: 14px;
			font-style: normal;
			font-weight: 400;
			line-height: 18px; /* 128.571% */
		}
		&--active span {
			color: #fff;
			font-weight: 500;
			cursor: pointer;
		}
	}
	.header-history-svg {
		margin: 0 1px;
	}

	.layout-footer {
		overflow: hidden;
		background: url(@/assets/images/footer_bg.png) no-repeat;
		background-size: cover;
		background-position: 0 0;
	}
}

.fixed-action {
	position: fixed;
	right: 40px;
	bottom: 64px;
	z-index: 22;
	padding: 30px 4px;
	display: flex;
	flex-direction: column;
	border-radius: 80px;
	background: #fff;
	text-align: center;
	filter: drop-shadow(1px 4px 16px rgba(0, 0, 0, 0.08));
	backdrop-filter: blur(7px);

	.action-block {
		cursor: pointer;

		& + .action-block {
			margin-top: 20px;
		}
		&:not(:first-child) {
			position: relative;

			&::before {
				content: '';
				position: absolute;
				top: -10px;
				left: 12px;
				right: 12px;
				height: 1px;
				background: #f2f3f5;
				transform: scaleY(0.5);
				pointer-events: none;
			}
		}
		&:hover {
			.action-block-span {
				color: var(--theme-color);
			}
			.c-action-svg {
				color: var(--theme-color) !important;
			}
		}
		&--disabled {
			cursor: not-allowed;

			.action-block-span {
				color: #c9cdd4;
			}
			.c-action-svg {
				color: #c9cdd4 !important;
			}
			&:hover {
				.action-block-span {
					color: #c9cdd4;
				}
				.c-action-svg {
					color: #c9cdd4 !important;
				}
			}
		}
	}
	.action-block-span {
		display: block;
		margin-top: 8px;
		color: #1d2129;
		font-family: 'SourceHanSansCN-Normal';
		font-size: 12px;
		font-style: normal;
		font-weight: 400;
		line-height: 16px; /* 133.333% */
	}
	.c-action-svg {
		color: #4e5969 !important;
	}
}

.fade-enter-active,
.fade-leave-active {
	transition: opacity 0.18s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
	opacity: 0;
}

.Mobile {
	.fixed-action {
		right: 14px;
		padding: 20px 4px;
	}
}

.cover-wrap {
	position: relative;
	height: 100vh;

	&::before {
		content: '';
		position: absolute;
		top: 0;
		left: 0;
		right: 0;
		bottom: 0;
		z-index: -1;
		background-color: var(--slide-bg, transparent);
	}
}

.cover-img {
	width: 100%;
	height: 100vh;
	object-fit: contain;
}
</style>
